
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Menu, MenuItem, Fade, Switch, FormControlLabel, FormGroup } from '@mui/material';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';

import CustomTableV2 from "../../common/CustomTableV2";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";
import TemplatePreview from "./components/TemplatePreview";
import { GetEmailTemplates, SetTemplateDefault } from "../../redux/emailTemplate/actions";

import "./style.css";

function EmailTemplates(props) {

    const [showModal, setShowModal] = useState(false);
    const [showModalPreview, setShowModalPreview] = useState(false);
    const [showType, setShowType] = useState("");
    const [emailTemplate, setEmailTemplate] = useState(null);
    const [htmlContent, setHTMLContent] = useState(null);

    // MENU STATES
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentIndex, setCurrentIndex] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (!showModalPreview) {
            setHTMLContent(null);
        }
    }, [showModalPreview])

    return (
        <div id="email-templates-wrapper" className="main-container">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="EMAIL TEMPLATES"
                        description="Add and Update Email Templates."
                        store={props.EmailTemplate}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Template Name" },
                                { title: "Tag" },
                                { title: "Is Default" },
                                { title: "" },
                                { title: "" },
                            ],
                            body: (et, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{et.name.toUpperCase()}</h5></td>
                                        <td><h5>{et.tag + (et?.version > 1 ? ("-v" + et?.version) : "")}</h5></td>
                                        <td>
                                            <Switch checked={et?.is_default} onClick={() => {
                                                props.SetTemplateDefault(et);
                                            }} label="" labelPlacement="start" />
                                        </td>
                                        <td><VisibilityIcon style={{ cursor: "pointer" }} onClick={() => {
                                            setHTMLContent(et.html_content);
                                            setShowModalPreview(true);
                                        }} /></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            setEmailTemplate(et);
                                                            handleClose();
                                                            setShowModal(true);
                                                            setShowType("edit");
                                                        }}><EditIcon sx={{ mr: '10px' }} /> Edit</MenuItem>
                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetEmailTemplates(page, count, { ...filter, owner: null }, sort);
                            },
                            add: () => {
                                setShowModal(true);
                                setEmailTemplate(null);
                            },
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"Email Template"}>
                <TemplatePreview et={emailTemplate} reset={() => {
                    setShowModal(false);
                    setEmailTemplate(null);
                }} />
            </CustomSliderModalV2>

            <CustomSliderModalV2 show={showModalPreview} setShow={setShowModalPreview} title={"Template Preview"}>
                <div>
                    <div className="preview" dangerouslySetInnerHTML={{ __html: htmlContent }} />
                </div>
            </CustomSliderModalV2>
        </div>
    );
}

const mapStateToProps = (state) => ({
    EmailTemplate: state.EmailTemplate,
})

export default connect(mapStateToProps, {
    GetEmailTemplates,
    SetTemplateDefault,
})(EmailTemplates);
